import axios from 'axios';
import firebase from 'firebase';
import { IS_WHOLESALE_ACCOUNT } from '../api/customer/routes';

let WHOLESALE_ACCOUNT_CHECKED = false;
let isWholesaleAccount = false;
export default async () => {
    if (typeof window !== 'undefined') {
        return false;
    }

    if (!firebase.auth().currentUser || axios.interceptors.request.handlers.length === 0) {
        return false;
    }

    if (WHOLESALE_ACCOUNT_CHECKED) {
        return isWholesaleAccount;
    }

    WHOLESALE_ACCOUNT_CHECKED = true;
    const isWholesaleAccountResponse = await axios.get(IS_WHOLESALE_ACCOUNT).catch(
        (error) => {
            // eslint-disable-next-line no-console
            console.log('error');
            // eslint-disable-next-line no-console
            console.log(error);
        },
    );

    if (isWholesaleAccountResponse && isWholesaleAccountResponse.data) {
        // eslint-disable-next-line prefer-destructuring
        isWholesaleAccount = isWholesaleAccountResponse.data.isWholesaleAccount;
        return isWholesaleAccount;
    }

    return false;
};
